import React from 'react';
import AppProvider from 'store/provider';
import wrapPageElementWithTransition from 'helpers/wrapPageElement';
import 'bootstrap/dist/css/bootstrap.css';

// React Context in Browser
// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => {
  return <AppProvider>{element}</AppProvider>;
};

// Page Transitions
export const wrapPageElement = wrapPageElementWithTransition;

export const onRouteUpdate = (win) => {
  console.log('onRouteUpdate', win.location)
  if (win.location && win.location.hash) {
    setTimeout(() => {
      console.log('onRouteUpdate', document.querySelector(`${win.location.hash}`))
      document.querySelector(`${win.location.hash}`).scrollIntoView();
    }, 0);
  } else {
    setTimeout(() => {
      window.scrollTo(0,0);
    }, 0);
  }
};
